import * as tokens from '../../../tokens/typography.generated.js';
export const systemTypography = {
    typography: {
        display: {
            order: {
                1: {
                    normal: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL
                },
                2: {
                    normal: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL
                },
                3: {
                    normal: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL
                }
            }
        },
        headline: {
            order: {
                1: {
                    normal: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL,
                    bold: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD
                },
                2: {
                    normal: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL,
                    bold: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD
                },
                3: {
                    normal: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL,
                    bold: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD
                },
                4: {
                    normal: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL,
                    bold: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD
                }
            }
        },
        copy: {
            order: {
                1: {
                    normal: tokens.SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL,
                    short: tokens.SYS_TYPOGRAPHY_COPY_ORDER1_SHORT,
                    bold: tokens.SYS_TYPOGRAPHY_COPY_ORDER1_BOLD,
                    shortBold: tokens.SYS_TYPOGRAPHY_COPY_ORDER1_SHORT_BOLD
                },
                2: {
                    normal: tokens.SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL,
                    short: tokens.SYS_TYPOGRAPHY_COPY_ORDER2_SHORT,
                    bold: tokens.SYS_TYPOGRAPHY_COPY_ORDER2_BOLD,
                    shortBold: tokens.SYS_TYPOGRAPHY_COPY_ORDER2_SHORT_BOLD
                },
                3: {
                    normal: tokens.SYS_TYPOGRAPHY_COPY_ORDER3_NORMAL,
                    short: tokens.SYS_TYPOGRAPHY_COPY_ORDER3_SHORT,
                    bold: tokens.SYS_TYPOGRAPHY_COPY_ORDER3_BOLD,
                    shortBold: tokens.SYS_TYPOGRAPHY_COPY_ORDER3_SHORT_BOLD
                },
                4: {
                    normal: tokens.SYS_TYPOGRAPHY_COPY_ORDER4_NORMAL,
                    short: tokens.SYS_TYPOGRAPHY_COPY_ORDER4_SHORT,
                    bold: tokens.SYS_TYPOGRAPHY_COPY_ORDER4_BOLD,
                    shortBold: tokens.SYS_TYPOGRAPHY_COPY_ORDER4_SHORT_BOLD
                }
            }
        }
    }
};
//# sourceMappingURL=system.js.map